var exports = {
  "kL": "x127c5a35--83f6ee--container",
  "nM": "x127c5a35--83f6ee--row",
  "RI": "x127c5a35--83f6ee--floor",
  "NW": "x127c5a35--83f6ee--type",
  "Wc": "x127c5a35--83f6ee--area",
  "q9": "x127c5a35--83f6ee--price",
};

module.exports = exports;
